import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isChecked", "className", "label", "onChange"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Switch from '../switch/Switch';
var TreeOption = function TreeOption(props) {
  var isChecked = props.isChecked,
    className = props.className,
    label = props.label,
    onChange = props.onChange,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var optionClasses = classNames('TreeOption', 'display-flex', 'justify-content-start', 'cursor-pointer', className);
  return /*#__PURE__*/React.createElement("div", _extends({}, remainingProps, {
    className: optionClasses,
    onClick: onChange
  }), /*#__PURE__*/React.createElement("span", {
    className: 'pointer-events-none scale-80'
  }, /*#__PURE__*/React.createElement(Switch, {
    keyName: 'TreeOption-switch',
    checked: isChecked
  })), /*#__PURE__*/React.createElement("span", {
    className: 'margin-left-5 padding-top-2'
  }, label));
};
TreeOption.displayName = 'TreeOption';
TreeOption.defaultProps = {
  isChecked: false,
  onChange: function onChange() {}
};
TreeOption.propTypes = {
  isChecked: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  className: PropTypes.string
};
export default TreeOption;